import {useRef, useState, useCallback} from 'react';

import {useAuthContext} from "src/auth/hooks";
import {getCommentListForRecipe} from "src/services/comment/list-api";

// ----------------------------------------------------------------------

export default function useCommentListForRecipe(recipeId, commentId = null, onChangeCallback) {
  const isLoading = useRef(false);
  const [isLoaded, setIsLoaded] = useState(false);
  const [commentList, setCommentList] = useState([]);
  const {user} = useAuthContext();
  const loadCommentData = useCallback(async (size = 10) => {
    if (isLoading.current) {
      return;
    }

    isLoading.current = true;

    const commentListData = await getCommentListForRecipe({recipeId, commentId, size});

    commentListData.items = commentListData.items?.map((comment) => {
      comment.doesBelongToUser = user?.pimcoreUserId === comment.userModel?.pimcoreUserId;
      return comment;
    });

    setCommentList(commentListData)
    if (onChangeCallback) {
      onChangeCallback(commentListData);
    }

    setIsLoaded(true);
    isLoading.current = false;
  }, [commentId, onChangeCallback, recipeId, user?.pimcoreUserId])

  return {
    commentList,
    loadCommentData,
    isLoaded,
    setIsLoaded
  };
}
